import * as React from "react";
import styled from "styled-components";

import { COLORS } from "@/react/theme/constants";
import { CopyButton } from "@/react/components/CopyButton";

import { KeyLabel, Row, RowContent } from "./styled";

const GreyedOut = styled.span`
  color: ${COLORS.gray10};
`;

const InfoRow = ({ renderIcon, attributeName, value }) => {
  return (
    <Row>
      {renderIcon()}
      <KeyLabel>{attributeName}:</KeyLabel>
      {value && (
        <RowContent>
          <span data-testid="value-span">{value}</span>
          <CopyButton value={value} />
        </RowContent>
      )}
      {!value && (
        <RowContent>
          <GreyedOut data-testid="fallback-span">No data.</GreyedOut>
        </RowContent>
      )}
    </Row>
  );
};

export default InfoRow;
